export default __webpack_public_path__ + "static/media/ic_shuttles_on.360ba83a.svg";